import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { propOneOf, propFunc, propBool, propStr, } from '@/helpers/custom-prop-types';
import ProffitSearchHeader from './SlideSearch';
import Header from './index';
const HeaderWrapper = (props) => {
    const { guestHeaderViewMode, headerClassName, headerType, onChangeKeyword, onChangeSearch, onClickGuestHeaderMenu, onSubmitSearch, showHeader, showSearch, } = props;
    switch (headerType) {
        case 'none':
            return null;
        case 'proffit_search':
            return (_jsx(ProffitSearchHeader, { className: headerClassName, isShow: showHeader }));
        default:
            return (_jsx(Header, { guestHeaderViewMode: guestHeaderViewMode, headerClassName: headerClassName, onChangeKeyword: onChangeKeyword, onChangeSearch: onChangeSearch, onClickGuestHeaderMenu: onClickGuestHeaderMenu, onSubmitSearch: onSubmitSearch, showSearch: showSearch }));
    }
};
HeaderWrapper.propTypes = {
    guestHeaderViewMode: propOneOf(['normal', 'expand']).isRequired,
    headerClassName: propStr(),
    headerType: propOneOf(['top', 'search', 'proffit_search', 'default', 'none'])
        .isRequired,
    onChangeKeyword: propFunc(),
    onChangeSearch: propFunc(),
    onClickGuestHeaderMenu: propFunc(),
    onSubmitSearch: propFunc(),
    showHeader: propBool().isRequired,
    showSearch: propBool().isRequired,
};
HeaderWrapper.defaultProps = {
    headerClassName: '',
    onChangeKeyword: undefined,
    onChangeSearch: undefined,
    onClickGuestHeaderMenu: undefined,
    onSubmitSearch: undefined,
};
export default HeaderWrapper;
